import { z } from 'zod';


export const InputSchema = z.object({
    accountId: z.number()
});

export type TInputSchema = z.infer<typeof InputSchema>;

export const SuccessResponseSchema = z.object({
    accountId: z.number(),
    universe: z.string(),
    xmlResponses: z.array(
        z.string(),
    ),
});

export type TSuccessResponse = z.infer<typeof SuccessResponseSchema>;

export const ErrorResponseSchema = z.object({
    error: z.object({
        code: z.string(),
        message: z.string()
    })
});

type TErrorResponse = z.infer<typeof ErrorResponseSchema>;

export type TResponseType =
    { responseStatus: 'success'; data: TSuccessResponse } |
    { responseStatus: 'error'; data: TErrorResponse } |
    {
        responseStatus: 'apiError',
        status: number,
        data?: unknown
    }
